// @ts-nocheck
import {
	applyBezierBookends,
	applyBezierToSingleSelection,
	applyBezierToMultipleSelections,
} from "./bezier";
import { getActiveComposition } from "./comp";
import { elasticEaseLayer } from "./elastic";
import { shiftKeyToNewOffset } from "./keyframes";
import {
	createElasticKeyframesOverwrite,
	createElasticKeyframesStop,
} from "./elastic";
import {
	bezier,
	rangeMap,
	enumFromTo,
	mapEasing,
} from "../../js/utilities/bezier-utils";
import { getSelectedLayers, getSelectedLayerTimes } from "./layers";
import {
	generalInputValidation,
	validateSelectedKeyframes,
	validateCubicBezierX,
	validateSelectedKeyframesDistribute,
} from "./validation";
import { moveLayers } from "./layers";
import { notify } from "./notifications";
import { ToolApplyRequest, PresetObj } from "../../js/types/general-types";
import {
	bounceEaseLayer,
	createBounceKeyframesStop,
	createBounceKeyframesOverwrite,
} from "./bounce";
import { mapPolyfill } from "../../js/utilities/bezier-utils";
import { retrieveLocalLicense, updateLicense } from "./licensing";
import { convertToBezierValues } from "./convert-ease-bez";

export { retrieveLocalLicense, updateLicense };

export const applyToolES = (req: ToolApplyRequest) => {
	let resObj: ESresObjType = {
		success: true,
		data: null,
		message: "",
	};
	let comp = getActiveComposition();
	let layers = getSelectedLayers();
	let noActiveItemMessage: string = "";
	if (req.tool === "distribute")
		noActiveItemMessage =
			"Please select keyframes or layers to apply the distribute to.";
	if (req.tool === "synergy")
		noActiveItemMessage = "Please select keyframes to apply the synergy to.";
	if (req.tool === "bezier")
		noActiveItemMessage = "Please select keyframes to apply the bezier to.";
	if (req.tool === "elastic")
		noActiveItemMessage = "Please select keyframes to apply the elastic to.";
	if (req.tool === "bounce")
		noActiveItemMessage = "Please select keyframes to apply the bounce to.";
	if (!comp || !layers?.length > 0)
		return JSON.stringify({
			success: false,
			data: {},
			message: noActiveItemMessage,
		});
	generalInputValidation(comp, layers);

	switch (req.tool) {
		case "bezier":
			resObj = bezierEase(req, comp, layers, resObj);
			break;
		case "elastic":
			resObj = elasticEase(req, comp, layers, resObj);
			break;
		case "bounce":
			resObj = bounceEase(req, comp, layers, resObj);
			break;
		case "distribute":
			resObj = distributeEase(req, comp, layers, resObj);
			break;
		case "synergy":
			resObj = synergyDistributeAndEase(req, comp, layers, resObj);
			break;
		default:
			break;
	}
	return JSON.stringify(resObj);
};

export const clearKeyframeEasing = () => {
	app.beginUndoGroup("clear keyframe easing");
	let comp = getActiveComposition();
	let layers = getSelectedLayers();
	if (!comp || !layers?.length > 0) return;
	for (let i = 0; i < layers.length; i++) {
		var layerPropArray: _PropertyClasses[] = comp.layer(
			layers[i]["index"]
		).selectedProperties;
		for (let j = 0; j < layerPropArray.length; j++) {
			let prop = layerPropArray[j] as Property<UnknownPropertyType>;
			if (prop instanceof PropertyGroup || prop instanceof MaskPropertyGroup)
				continue;
			let selectedKeys = prop.selectedKeys;
			for (let k = 0; k < selectedKeys.length; k++) {
				prop.setInterpolationTypeAtKey(
					selectedKeys[k],
					KeyframeInterpolationType.LINEAR,
					KeyframeInterpolationType.LINEAR
				);
			}
		}
	}
	app.endUndoGroup();
};

export const readKeyframePairEasing = () => {
	let comp = getActiveComposition();
	let layers = getSelectedLayers();
	//search all selected layers for keyframes
	//if there are only 2 selected keyframes on a single layer, return the easing of those keyframes
	for (let i = 0; i < layers.length; i++) {
		var layerPropArray: _PropertyClasses[] = comp.layer(
			layers[i]["index"]
		).selectedProperties;
		for (let j = 0; j < layerPropArray.length; j++) {
			let prop = layerPropArray[j] as Property<UnknownPropertyType>;
			if (prop instanceof PropertyGroup || prop instanceof MaskPropertyGroup)
				continue;
			let selectedKeys = prop.selectedKeys;
			if (
				selectedKeys.length === 2 &&
				selectedKeys[0] === selectedKeys[1] - 1
			) {
				let converted = convertToBezierValues(prop, selectedKeys[0]);
				converted.success = true;
				return JSON.stringify(converted);
			} else if (
				selectedKeys.length === 2 &&
				selectedKeys[0] !== selectedKeys[1] - 1
			) {
				let easeOut = convertToBezierValues(prop, selectedKeys[0]);
				let easeIn = convertToBezierValues(prop, selectedKeys[1] - 1);
				let res = {
					in: { x: easeOut["in"]["x"], y: easeOut["in"]["y"] },
					out: { x: easeIn["out"]["x"], y: easeIn["out"]["y"] },
					duration: false,
					success: true,
				};
				return JSON.stringify(res);
			} else if (
				selectedKeys.length === 1 &&
				selectedKeys[0] !== 1 &&
				selectedKeys[0] !== prop.numKeys
			) {
				let easeOut = convertToBezierValues(prop, selectedKeys[0] - 1);
				let easeIn = convertToBezierValues(prop, selectedKeys[0]);
				let res = {
					in: { x: easeIn["in"]["x"], y: easeIn["in"]["y"] },
					out: { x: easeOut["out"]["x"], y: easeOut["out"]["y"] },
					duration: false,
					success: true,
				};
				return JSON.stringify(res);
			}
		}
	}
	return JSON.stringify({
		success: false,
		data: {},
		message: "Please select 2 keys in order to read their values.",
	});
};

export function saveCustomPresets(value: PresetObj[]) {
	app.preferences.savePrefAsString("presets", "custom", JSON.stringify(value));
	app.preferences.saveToDisk();
	app.preferences.reload();
	return value;
}

export function loadCustomPresets(): string | undefined {
	const hasCustomPresets = app.preferences.havePref("presets", "custom")
	if (!hasCustomPresets) {
		return "[]";
	} else {
		const presetEasings = app.preferences.getPrefAsString("presets", "custom")
		return presetEasings;
	}
}

export function savePresetOrdering(value: string[], tool: string) {
	app.preferences.savePrefAsString(
		"presets",
		`${tool}_presets_ordering`,
		JSON.stringify(value)
	);
	app.preferences.saveToDisk();
	app.preferences.reload();
	return value;
}

export function loadPresetOrdering(tool: string): string {
	const hasOrdering = app.preferences.havePref(
		"presets",
		`${tool}_presets_ordering`
	);
	if (!hasOrdering) {
		return "[]";
	} else {
		const ordering = app.preferences.getPrefAsString(
			"presets",
			`${tool}_presets_ordering`
		);
		return ordering;
	}
}

export function saveFavoritePresets(value: string) {
	app.preferences.savePrefAsString(
		"presets",
		"favorites",
		JSON.stringify(value)
	);
	app.preferences.saveToDisk();
	app.preferences.reload();
	return value;
}

export function loadFavoritePresets(): string | undefined {
	const hasFavoritePresets = app.preferences.havePref("presets", "favorites");
	if (!hasFavoritePresets) {
		return "{}";
	} else {
		const favoritePresets = app.preferences.getPrefAsString(
			"presets",
			"favorites"
		);
		return favoritePresets;
	}
}

function synergyDistributeAndEase(req: ToolApplyRequest, comp: CompItem, layers: Layer[], resObj: ESResObjType) {
	let noKeyframesNotification = false;
	let keyframePairArr = [];
	let earliestFoundKeyframe = Infinity;
	for (let i = 0; i < layers.length; i++) {
		var layerPropArray: _PropertyClasses[] = comp.layer(layers[i]['index']).selectedProperties
		if (layers[i].matchName === "ADBE Vector Layer") {
			layerPropArray = sortShapesInShapeLayer(layerPropArray)
		} else {
			layerPropArray = layerPropArray.sort((a, b) => { return a.propertyIndex - b.propertyIndex })
		}
		for (let j = 0; j < layerPropArray.length; j++) {
			let currProperty = layerPropArray[j] as Property<UnknownPropertyType>;
			if (currProperty instanceof PropertyGroup || currProperty instanceof MaskPropertyGroup) continue;
			let selectedKeyframes = validateSelectedKeyframes(layerPropArray[j]);
			if (!selectedKeyframes.length) {
				if (!noKeyframesNotification) {
					// alert(notify.noKeyframes);
					// resObj = { success: false, data: null, message: notify.noKeyframes }
					noKeyframesNotification = true;
				}
			} else if (selectedKeyframes.length >= 2) {
				if (currProperty.keyTime(selectedKeyframes[0]) < earliestFoundKeyframe) earliestFoundKeyframe = currProperty.keyTime(selectedKeyframes[0]);
				keyframePairArr.push({
					property: currProperty,
					inIndex: selectedKeyframes[selectedKeyframes.length - 2],
					outIndex: selectedKeyframes[selectedKeyframes.length - 1]
				})
			}
		}
	}
	let inEase = validateCubicBezierX(req.userVars.inEase);
	let outEase = validateCubicBezierX(req.userVars.outEase);
	let deltasArr = [];
	for (let i = 0; i < 4; i++) {
		deltasArr[i] = inEase[i] - outEase[i];
	}
	let deltaIncrement = [];
	for (let i = 0; i < 4; i++) {
		deltaIncrement[i] = deltasArr[i] / keyframePairArr.length;
	}
	let values = validateCubicBezierX(req.values);
	//@ts-ignore
	const easing = bezier(values[0], values[1], values[2], values[3]);
	const mapping = rangeMap([1, keyframePairArr.length], [0, 1])
	const layersArr = enumFromTo(1, keyframePairArr.length)
	let rangeMappedLayers = mapEasing(mapping, layersArr)
	let updatedStartTimes: number[] = []
	for (var i = 0; i < rangeMappedLayers.length; i++) {
		updatedStartTimes[i] = easing(rangeMappedLayers[i]) * req.userVars.numFrames;
	}
	if (req.userVars.isInverted) updatedStartTimes = updatedStartTimes.reverse();

	app.beginUndoGroup("Lazy Layers");
	for (let i = 0; i < keyframePairArr.length; i++) {
		applyBezierBookends(
			keyframePairArr[i].property,
			keyframePairArr[i].inIndex,
			keyframePairArr[i].outIndex,
			validateCubicBezierX(req.userVars.outEase)
		);
		shiftKeyToNewOffset(
			keyframePairArr[i].property,
			keyframePairArr[i].outIndex,
			updatedStartTimes[i] * comp.frameDuration,
			keyframePairArr[i].outIndex
		);
		shiftKeyToNewOffset(
			keyframePairArr[i].property,
			keyframePairArr[i].inIndex,
			updatedStartTimes[i] * comp.frameDuration,
			keyframePairArr[i].inIndex
		);
		for (let i = 0; i < 4; i++) {
			req.userVars.outEase[i] += deltaIncrement[i];
		}
	}
	app.endUndoGroup();
	return keyframePairArr.length
		? resObj
		: { success: false, data: null, message: notify.noKeyframes };
}

//TODO: finalize UI visualization logic for elastic/bounce
//PROBLEM: elastic + bounce derive velocity from internal AE keyframe values
//       - we expect users to apply elastic || bounce to more than a single layer
//       - how do we choose which layer to derive velocity from?
export function getIncomingVelocity(): number {
	return 1;
};


function sortShapesInShapeLayer(shapeLayerProps: ShapeLayer) {
	let layerProperties = [];
	let i = 0;
	while (shapeLayerProps[i] !== undefined && shapeLayerProps[i].matchName !== "ADBE Vector Group") {
		layerProperties.push(shapeLayerProps[i]);
		i++;
	}
	layerProperties.sort((a, b) => { return a.propertyIndex - b.propertyIndex });
	let shapeProperties = [];
	for (let j = i; j < shapeLayerProps.length; j++) {
		if (shapeLayerProps[j].matchName === "ADBE Vector Group") {
			j++;
			let shapePropArr = [];
			let k = j;
			while (shapeLayerProps[k] !== undefined && shapeLayerProps[k].matchName !== "ADBE Vector Group") {
				shapePropArr.push(shapeLayerProps[k]);
				k++;
			}
			shapePropArr.sort((a, b) => { return a.propertyIndex - b.propertyIndex });
			shapeProperties = shapeProperties.concat(shapePropArr);
			j = k - 1;
		}
	}
	let res = shapeProperties.concat(layerProperties);
	return res;
}

//We need to get selected layers and keyframes
//TODO: Refactor, no need to traverse ALL selected properties twice.
const distributeEase = (req: ToolApplyRequest, comp: CompItem, layers: string | any[], resObj: ESResObjType) => {

	const recurse = function (propertyGroup, keyframeArr) {
		let selectedProps = []
		for (let k = 0; k < propertyGroup.length; k++) {
			if (propertyGroup[k] === GROUP) recurse(prop, keyframeArr)
			selectedProps.push(propertyGroup[k])
		}
		keyframeArr.push(selectedProps)
	}

	let earliestFoundKeyframe = Infinity;
	let keyframesInPropertyArr = [];
	for (let i = 0; i < layers.length; i++) {
		var layerPropArray: _PropertyClasses[] = comp.layer(layers[i]['index']).selectedProperties
		if (layers[i].matchName === "ADBE Vector Layer") {
			layerPropArray = sortShapesInShapeLayer(layerPropArray)
		} else {
			layerPropArray = layerPropArray.sort((a, b) => { return a.propertyIndex - b.propertyIndex })
		}
		for (let j = 0; j < layerPropArray.length; j++) {
			let currProperty = layerPropArray[j] as Property<UnknownPropertyType>;
			if (currProperty instanceof PropertyGroup || currProperty instanceof MaskPropertyGroup) continue;
			let selectedKeyframes = validateSelectedKeyframesDistribute(layerPropArray[j]);
			if (selectedKeyframes.length) {
				foundKeyframe = true;
				if (currProperty.keyTime(selectedKeyframes[0]) < earliestFoundKeyframe) earliestFoundKeyframe = currProperty.keyTime(selectedKeyframes[0]);
				keyframesInPropertyArr.push({
					property: currProperty,
					keyframes: selectedKeyframes
				})
			}
		}
	}
	app.beginUndoGroup('Distribute Keyframes')
	if (keyframesInPropertyArr.length === 1) {
		// alert(notify.pleaseSelectOneOrMoreKeyframes);
		resObj = { success: false, data: null, message: notify.pleaseSelectOneOrMoreKeyframes }
		return resObj;
	} else if (keyframesInPropertyArr.length) {
		distributeKeyframesAlongBezier(req, comp, layers, earliestFoundKeyframe, keyframesInPropertyArr);
	} else {
		distributeLayersAlongBezier(req);
	}
	app.endUndoGroup();
	return resObj;
}

const distributeLayersAlongBezier = (req: ToolApplyRequest) => {
	//@ts-ignore
	let values: [] = req.values;
	//@ts-ignore
	values = mapPolyfill(values, function (x) { return 1 - x; });
	const { numFrames } = req.userVars;
	const layerArr = getSelectedLayerTimes()
	if (layerArr.length <= 1) {
		// alert(notify.insufficientLayers);
		resObj = { success: false, data: null, message: notify.insufficientLayers }
		return resObj;
	}
	let earliestLayerStartTime = Infinity;
	for (let i = 0; i < layerArr.length; i++) {
		if (layerArr[i].time < earliestLayerStartTime) {
			earliestLayerStartTime = layerArr[i].time
		}
	}
	//@ts-ignore
	const sortedLayerArr = layerArr.sort((a, b) => a.index - b.index)
	//@ts-ignore
	const easing = bezier(values[0], values[1], values[2], values[3]); //returns function that gives X for a range
	const mapping = rangeMap([1, sortedLayerArr.length], [0, 1]) //returns function that maps val in first range to second
	const layers = enumFromTo(1, sortedLayerArr.length)   //creates array of numbers from 1 to layerArr.length
	let rangeMappedLayers = mapEasing(mapping, layers) // 0 indexed, applies mapping function to each in layers
	let updatedStartTimes: number[] = []
	for (var i = 0; i < rangeMappedLayers.length; i++) {
		updatedStartTimes[i] = easing(rangeMappedLayers[i]) * numFrames
		updatedStartTimes[i] += earliestLayerStartTime * sortedLayerArr[0].frameRate
	}
	if (!req.userVars.isInverted) updatedStartTimes = updatedStartTimes.reverse()
	moveLayers(updatedStartTimes, sortedLayerArr);
}

const distributeKeyframesAlongBezier = (
	req: ToolApplyRequest,
	comp: CompItem,
	layers: string | any[],
	earliestFoundKeyframe: number,
	keyframesInPropertyArr: number
) => {
	let values = validateCubicBezierX(req.values);
	//@ts-ignore
	const easing = bezier(1-values[0], 1-values[1], 1-values[2], 1-values[3]);
	const mapping = rangeMap([1, keyframesInPropertyArr.length], [0, 1]);
	const layersArr = enumFromTo(1, keyframesInPropertyArr.length);
	let rangeMappedLayers = mapEasing(mapping, layersArr);
	let updatedStartTimes: number[] = [];
	for (var i = 0; i < rangeMappedLayers.length; i++) {
		updatedStartTimes[i] =
			easing(rangeMappedLayers[i]) * req.userVars.numFrames;
	}
	if (!req.userVars.isInverted) updatedStartTimes = updatedStartTimes.reverse();
	for (let i = 0; i < keyframesInPropertyArr.length; i++) {
		for (
			let j = keyframesInPropertyArr[i]["keyframes"].length - 1;
			j >= 0;
			j--
		) {
			shiftKeyToNewOffset(
				keyframesInPropertyArr[i].property,
				keyframesInPropertyArr[i]["keyframes"][j],
				updatedStartTimes[i] * comp.frameDuration,
				keyframesInPropertyArr[i]["keyframes"][j]
			);
		}
	}
};

const bezierEase = (
	req: ToolApplyRequest,
	comp: CompItem,
	layers: string | any[],
	resObj: ESResObjType
) => {
	app.beginUndoGroup("bezier ease");
	let success = false;
	//@ts-ignore
	const values: [number, number, number, number] = validateCubicBezierX(
		req.values
	);
	for (let i = 0; i < layers.length; i++) {
		var layerPropArray: _PropertyClasses[] = comp.layer(
			layers[i]["index"]
		).selectedProperties;
		for (let j = 0; j < layerPropArray.length; j++) {
			let currProperty = layerPropArray[j] as Property<UnknownPropertyType>;
			if (
				currProperty instanceof PropertyGroup ||
				currProperty instanceof MaskPropertyGroup
			)
				continue;
			let selectedIndices = validateSelectedKeyframes(layerPropArray[j]);
			if (selectedIndices.length === 0) {
				// alert(notify.noKeyframes);
				resObj = {
					success: false,
					message: notify.pleaseAddOneOrMoreKeyframes,
					data: null,
				};
			} else if (selectedIndices.length === 1 && currProperty.numKeys === 1) {
				//alert(notify.pleaseAddOneOrMoreKeyframes)
				resObj = {
					success: false,
					message: notify.pleaseAddOneOrMoreKeyframes,
					data: null,
				};
			} else if (selectedIndices.length === 1 && currProperty.numKeys >= 2) {
				applyBezierToSingleSelection(currProperty, selectedIndices[0], values);
				success = true;
			} else if (
				selectedIndices.length === 2 &&
				Math.abs(selectedIndices[0] - selectedIndices[1]) === 1
			) {
				applyBezierBookends(
					currProperty,
					selectedIndices[0],
					selectedIndices[1],
					values
				);
				success = true;
			} else {
				applyBezierToMultipleSelections(currProperty, selectedIndices, values);
				success = true;
			}
		}
	}
	app.endUndoGroup();
	return success
		? { success: true, message: notify.success, data: null }
		: resObj;
};

const bounceEase = (
	req: ToolApplyRequest,
	comp: CompItem,
	layers: string | any[],
	resObj: ESResObjType
) => {
	app.beginUndoGroup("bounce ease");
	let keyframesToWrite = [];
	for (let i = 0; i < layers.length; i++) {
		var props = comp.layer(layers[i]["index"]).selectedProperties;
		for (let j = 0; j < props.length; j++) {
			//TODO: add validation for bounce + elastic
			let selectedIndices = validateSelectedKeyframes(props[j]);
			if (selectedIndices.length > 1) {
				let keyframes = bounceEaseLayer(req, comp, props[j], req.values);
				let keyframeWriteReq = {
					prop: props[j],
					keyframes: keyframes,
					selectedIndices: selectedIndices,
				};
				keyframesToWrite.push(keyframeWriteReq);
			}
		}
	}
	for (let k = 0; k < keyframesToWrite.length; k++) {
		if (req.config.keyframeCollisionBehavior == "overwrite") {
			createBounceKeyframesOverwrite(
				req,
				comp,
				keyframesToWrite[k].prop,
				keyframesToWrite[k].selectedIndices,
				keyframesToWrite[k].keyframes
			);
		} else if (req.config.keyframeCollisionBehavior == "stop") {
			createBounceKeyframesStop(
				req,
				comp,
				keyframesToWrite[k].prop,
				keyframesToWrite[k].selectedIndices,
				keyframesToWrite[k].keyframes
			);
		}
	}
	app.endUndoGroup();
	return keyframesToWrite.length
		? resObj
		: {
				success: false,
				message: notify.pleaseSelectOneOrMoreKeyframes,
				data: null,
		  };
};

const elasticEase = (
	req: ToolApplyRequest,
	comp: CompItem,
	layers: string | any[],
	resObj: ESResObjType
) => {
	app.beginUndoGroup("Lazy Layers");
	let keyframesToWrite = [];
	for (let i = 0; i < layers.length; i++) {
		let layer = comp.layer(layers[i]["index"]);
		var props = layer.selectedProperties;
		for (let j = 0; j < props.length; j++) {
			let selectedIndices = validateSelectedKeyframes(props[j]);
			if (selectedIndices.length > 1) {
				let keysframes = elasticEaseLayer(props[j], req, selectedIndices);
				let keyframeWriteReq = {
					prop: props[j],
					keyframes: keysframes,
					selectedIndices: selectedIndices,
				};
				keyframesToWrite.push(keyframeWriteReq);
			}
		}
	}
	for (let k = 0; k < keyframesToWrite.length; k++) {
		if (req.config.keyframeCollisionBehavior == "overwrite") {
			createElasticKeyframesOverwrite(
				req,
				comp,
				keyframesToWrite[k].prop,
				keyframesToWrite[k].selectedIndices,
				keyframesToWrite[k].keyframes
			);
		} else if (req.config.keyframeCollisionBehavior == "stop") {
			createElasticKeyframesStop(
				req,
				comp,
				keyframesToWrite[k].prop,
				keyframesToWrite[k].selectedIndices,
				keyframesToWrite[k].keyframes
			);
		}
	}
	app.endUndoGroup();
	return keyframesToWrite.length
		? resObj
		: {
				success: false,
				message: notify.pleaseSelectOneOrMoreKeyframes,
				data: null,
		  };
};

if (!String.prototype.includes) {
	String.prototype.includes = function (search, start) {
		"use strict";
		if (typeof start !== "number") {
			start = 0;
		}

		if (start + search.length > this.length) {
			return false;
		} else {
			return this.indexOf(search, start) !== -1;
		}
	};
}
